import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import "../../styles/gym-cities/gym-cities.css";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import { fetchGymCitiesData } from "../../redux/website-reducers/websiteSlice";
import GymCitiesListings from "../../components/gym-cities/GymCitiesListings";
import MappedGyms from "../../components/gym-cities/MappedGyms";
import GymMetadatForm from "./GymMetadatForm";

const GymCities = () => {
  const userInfoData = useSelector(selectUser);
  const dispatch = useDispatch();

  const iniModvalues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  function getGymCitties(filters = {}) {
    dispatch(
      fetchGymCitiesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getGymCitties();
  }, []);

  return (
    <HelmetWrapper title="WTF: Expense Categories">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}
        >
          {modValues.modName === "manage_metadata" ? (
            <GymMetadatForm
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              callFunction={() => getGymCitties()}
            />
          ) : modValues.modName === "mapped_locations" ? (
            <MappedGyms
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeModal={() => {
                onCloseModal();
                getGymCitties();
              }}
            />
          ) : null}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Manage gym cities"}
              isReload={() => getGymCitties()}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <GymCitiesListings setModValues={setModValues} />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default GymCities;